// extracted by mini-css-extract-plugin
export default {"box":"index_box__FceMY","big_title":"index_big_title__NDvpY","cont":"index_cont__Of5Q2","link":"index_link__n6s6R","tag":"index_tag__1rrpX"};